import React from "react";
import {
  AiOutlineFolderAdd,
  AiOutlineGift,
} from "react-icons/ai";
import {
  FiPackage,
  FiShoppingBag,
} from "react-icons/fi";
import { RxDashboard } from "react-icons/rx";
import { CiMoneyBill, CiSettings, CiLogout } from "react-icons/ci";
import { HiOutlineReceiptRefund } from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import axios from "axios"; 
import { server } from "../../../server"; 

const DashboardSideBar = () => {
  const location = useLocation();
  const currentPath = location.pathname;



  const logoutHandler = async () => {
    try {
      await axios.get(`${server}/shop/logout`, { withCredentials: true });
      window.location.href = "/";
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const isActive = (item) => {
    if (item.exact) {
      return currentPath === item.path;
    }
    if (item.dynamic) {
      return currentPath.startsWith(item.path);
    }
    return currentPath.startsWith(item.path) && currentPath !== "/dashboard"; 
  };

  const menuItems = [
    {
      id: 1,
      name: "Dashboard",
      icon: <RxDashboard size={24} />,
      path: "/dashboard",
      exact: true, 
    },
    {
      id: 2,
      name: "All Orders",
      icon: <FiShoppingBag size={24} />,
      path: "/dashboard-orders",
    },
    {
      id: 3,
      name: "All Products",
      icon: <FiPackage size={24} />,
      path: "/dashboard-products",
    },
    {
      id: 4,
      name: "Create Product",
      icon: <AiOutlineFolderAdd size={24} />,
      path: "/dashboard-create-product",
    },
    {
      id: 7,
      name: "Account Transaction",
      icon: <CiMoneyBill size={24} />,
      path: `/dashboard-shop-account-transactions`, 
    },
    {
      id: 9,
      name: "Discount Codes",
      icon: <AiOutlineGift size={24} />,
      path: "/dashboard-coupouns",
    },
    {
      id: 10,
      name: "Refunds",
      icon: <HiOutlineReceiptRefund size={24} />,
      path: "/dashboard-refunds",
    },
    {
      id: 11,
      name: "Settings",
      icon: <CiSettings size={24} />,
      path: "/settings",
    },
  ];

  return (
    <div
      className="flex flex-col
                 w-16 sm:w-64
                 h-screen
                 bg-white
                 shadow-lg
                 overflow-y-auto
                 sticky
                 top-0
                 left-0
                 z-10
                 transition-width
                 duration-300
                 ease-in-out"
    >
      <div className="flex flex-col flex-grow">
        {menuItems.map((item) => {
          const active = isActive(item);
          return (
            <Link
              key={item.id}
              to={item.path}
              className={`flex items-center px-4 py-3 my-1 rounded-md transition-colors duration-200 ${
                active
                  ? "bg-green-100 text-green-800"
                  : "text-gray-600 hover:bg-gray-100 hover:text-green-800"
              }`}
              aria-current={active ? "page" : undefined}
            >
              <div className={`flex justify-center w-8`}>
                <div className={`${active ? "text-green-800" : "text-gray-600"}`}>
                  {item.icon}
                </div>
              </div>
              <span className="ml-3 hidden sm:inline text-lg font-medium">
                {item.name}
              </span>
            </Link>
          );
        })}

        {/* Logout Button */}
        <div
          onClick={logoutHandler}
          className="flex items-center px-4 py-3 my-1 rounded-md cursor-pointer text-gray-600 hover:bg-gray-100 hover:text-green-800 transition-colors duration-200"
        >
          <div className="flex justify-center w-8">
            <CiLogout size={24} />
          </div>
          <span className="ml-3 hidden sm:inline text-lg font-medium">Logout</span>
        </div>
      </div>
    </div>
  );
};

export default DashboardSideBar;
